import { ChangeDetectorRef, Directive, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { Customer } from '@df/session/api/customer';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BasketQtyComponentDef implements OnInit, OnDestroy {
    private basketSubscription?: Subscription;

    get basket() {
        return this.customer.basket;
    }

    constructor(
        protected _ref: ChangeDetectorRef,
        private customer: Customer
    ) {
        this._ref.detach();
    }

    ngOnInit() {
        this.detectChanges();
        this.basketSubscription = this.basket.subscribe(() => this.detectChanges());
    }

    ngOnDestroy() {
        this.basketSubscription?.unsubscribe();
    }

    detectChanges() {
        if (!(<ViewRef>this._ref).destroyed) {
            this._ref.detectChanges();
        }
    }
}
